"use strict";

module.exports = function (method) {
  return function (item) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return item[method].apply(item, args);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/utils/invoke.js
// module id = 337
// module chunks = 37